module.exports = __webpack_public_path__ + "/images/8jrOd1x.gif";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/superman.gif
// module id = 249
// module chunks = 0